import angular from 'angular';
import userEditFormComponent from './user-edit-form.component';

export default angular.module('common.components.userEditForm', [])
  .component('userEditForm', userEditFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/user-edit-form/user-edit-form.module.js